import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as style from './style.module.css';

const Checkbox = ({type = "checkbox", title = '', value = '', register = {}, disabled = false, readOnly = false}) => (
    <label className={`${style.field} ${disabled || readOnly ? style.disabled : ''}`}>
        <input {...register} className={style.input} value={value} type={type} readOnly={readOnly} disabled={disabled || readOnly}/>
        <div className={style.box} ><FontAwesomeIcon icon={faCheck}/></div>
        {title}
    </label>
)

export default Checkbox;
